export default __webpack_public_path__ + "static/media/README.c508f261.md";